import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, AuthCallback, ProtectedRoute } from "@/lib/auth";
import Hero from "@/pages/Hero";
import Ingestion from "@/pages/Ingestion";
import Blueprint from "@/pages/Blueprint";
import PlanView from "@/pages/PlanView";
import Library from "@/pages/Library";
import Admin from "@/pages/Admin";
import Pricing from "@/pages/Pricing";
import PaymentResult from "@/pages/PaymentResult";
import Account from "@/pages/Account";

function AppRoutes() {
  const location = useLocation();
  // Process the OAuth redirect (#session_id=...) BEFORE any route/guard runs.
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      <Route path="/" element={<Hero />} />
      <Route path="/start" element={<ProtectedRoute><Ingestion /></ProtectedRoute>} />
      <Route path="/library" element={<ProtectedRoute><Library /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/billing-mockup" element={<Navigate to="/pricing" replace />} />
      <Route path="/payment/success" element={<PaymentResult />} />
      <Route path="/payment/cancel" element={<PaymentResult />} />
      <Route path="/account" element={<ProtectedRoute><Account /></ProtectedRoute>} />
      <Route path="/plan/:id/blueprint" element={<ProtectedRoute><Blueprint /></ProtectedRoute>} />
      <Route path="/plan/:id" element={<PlanView />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-white text-gray-950">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
